import React from 'react';
import { Box } from '@apia/theme';
import { TResponsiveTableCellRendererProps } from '../types';

const NoMemoAdditionalColumnDefaultRenderer = ({
  column,
  cell,
}: TResponsiveTableCellRendererProps) => {
  return (
    <Box
      className={`${cell.className ?? ''} responsiveTable__additionalInfoItem`}
      id={cell.id}
      title={cell.title}
    >
      <Box as="strong">{column.label ?? column.name}:</Box> {cell.children}
    </Box>
  );
};

export const AdditionalColumnDefaultRenderer = React.memo(
  NoMemoAdditionalColumnDefaultRenderer,
);
